import { getPaymentsApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ManualPaymentConfirmRequest } from '@/core/generated/api';

/** Подтверждает оплату по внешнему номеру платежа */
export const manualPaymentConfirmationService = {
    /** Отправляет ручное подтверждение платежа */
    async confirm(request: ManualPaymentConfirmRequest): Promise<void> {
        try {
            await getPaymentsApi()
                .apiV1PaymentsManualConfirmPost({
                    manualPaymentConfirmRequest: request,
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
